import { z } from 'zod';

/** How the gate cookie was granted (IMM-1356): the Google round-trip, or the agent bearer token. */
export const SandboxGateViaSchema = z.enum(['google', 'agent']);
export type SandboxGateVia = z.infer<typeof SandboxGateViaSchema>;

export const SandboxGateResponseSchema = z.object({
  authorised: z.boolean(),
  googleEmail: z.string().nullable(),
  /** `null` exactly when `authorised` is false. */
  via: SandboxGateViaSchema.nullable(),
});

export const SandboxGateStartQuerySchema = z.object({
  state: z.string().max(2048).optional(),
});

export const SandboxGateStartResponseSchema = z.object({
  url: z.url(),
});

export const SandboxGateCallbackBodySchema = z.object({
  code: z.string().min(1),
  state: z.string().min(1),
});

export const SandboxGateCallbackResponseSchema = z.object({
  googleEmail: z.email(),
});

export const SandboxSessionBodySchema = z.object({
  email: z.email(),
});

export const SandboxSessionResponseSchema = z.object({
  accessToken: z.string().min(1),
});

export const SandboxMemberSchema = z.object({
  email: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  /** Display names of the workspaces the user holds an active membership in. */
  workspaces: z.array(z.string()),
});

export const SandboxMembersResponseSchema = z.object({
  members: z.array(SandboxMemberSchema),
});

export type SandboxMember = z.infer<typeof SandboxMemberSchema>;
